import { useTranslation } from "react-i18next";
import { img } from "@/lib/images";

export default function ReserveBanner() {
  const { t } = useTranslation();
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src={img("home/hero-slider-04.jpg")}
        alt="Bali VW Tour"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-primary-950/80"></div>
      <div className="relative max-w-3xl mx-auto px-4 md:px-8 flex flex-col items-center text-center gap-6">
        <h2 className="font-heading text-3xl md:text-5xl text-background-50 leading-[1.1] tracking-tight">
          {t("reserve_headline")}
        </h2>
        <p className="text-background-200 text-base md:text-lg leading-relaxed max-w-2xl">
          {t("reserve_sub")}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-2">
          <a
            href="https://wa.me/6281246218000"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-accent-100 border border-background-50/40 hover:border-accent-400 text-background-50 hover:text-foreground-950 px-8 py-4 rounded-md font-semibold uppercase tracking-wide text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-whatsapp-line text-2xl text-[#25D366]"></i>
            {t("reserve_whatsapp")}
          </a>
        </div>
      </div>
    </section>
  );
}